import { supabase } from '@/integrations/supabase/client'

export const getQuestionImagePublicUrl = (imagePath: string | null): string | null => {
  if (!imagePath) return null

  // Handle case where imagePath is already a full URL
  if (imagePath.startsWith('http')) {
    // Clean up double slashes after the protocol
    return imagePath.replace(/(https?:\/\/)\/+/g, '$1')
  }

  // For storage paths, clean up all leading and duplicate slashes
  const cleanPath = imagePath.replace(/\/+/g, '/').replace(/^\//, '')

  const { data } = supabase.storage.from('question-visuals').getPublicUrl(cleanPath)

  return data?.publicUrl || null
}
